import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { AccountListing, AccountSummary } from '~/models/administration/account';
import { SiteLisitng } from '~/models/administration/site';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class AccountsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.administration);
  }

  getAccounts(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<AccountSummary[]>(this._url(`/grid-data`), model ?? {}, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  GetAccountsSitesDrop() {
    return this.http.get<AccountSummary[]>(this._url(`/Accounts-Sites`));
  }

  getAccountsListing() {
    return this.http.get<AccountListing[]>(this._url());
  }

  getAvailableStorage() {
    return this.http.get<any>(this._url(`/storage`));
  }

  getTimezones() {
    return this.http.get<any>(this._url(`/timezones`));
  }

  getSitesListByAccount(accountId: any) {
    return this.http.get<SiteLisitng[]>(this._url(`/sitesByAccount/${accountId}`));
  }

  getSiteBySiteId(siteId: any) {
    return this.http.get<SiteLisitng[]>(this._url(`/siteBySiteId/${siteId}`));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/accounts${v}`);
  }
}
